import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

/**
 * Hook para remover um produto do catálogo (core.Product)
 */
const useDeleteCoreProduct = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => {
      return fetch(`${API}/api/semeadora/core_products/${id}/`, {
        method: "DELETE",
      }) as Promise<null>;
    },
    onSuccess: (_, id) => {
      // Invalidar cache da lista
      queryClient.invalidateQueries({ queryKey: ["core-products"] });
      // Invalidar cache do produto específico
      queryClient.invalidateQueries({
        queryKey: ["core_product", id],
      });
    },
    onError: (error) => {
      console.error("Erro ao remover core_product", error);
    },
  });
};

export default useDeleteCoreProduct;
